(function () {
  'use strict';

  function initDimensionsTabs() {
    document.querySelectorAll('.dimensions-tab').forEach(function (wrapper) {
      var buttons = wrapper.querySelectorAll('.dimensions-tab__btn');
      var panels  = wrapper.querySelectorAll('.dimensions-tab__panel');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetTab = btn.dataset.tab;
          var productId = wrapper.id.replace('dimensions-tab-', '');

          buttons.forEach(function (b) {
            b.classList.remove('dimensions-tab__btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('dimensions-tab__btn--active');
          btn.setAttribute('aria-selected', 'true');

          panels.forEach(function (panel) {
            if (panel.id === 'dims-' + targetTab + '-' + productId) {
              panel.classList.add('dimensions-tab__panel--active');
              panel.removeAttribute('hidden');
            } else {
              panel.classList.remove('dimensions-tab__panel--active');
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDimensionsTabs);
  } else {
    initDimensionsTabs();
  }

  document.addEventListener('shopify:section:load', initDimensionsTabs);
})();